import { Pipe, PipeTransform } from '@angular/core';
import { Request } from '../../classes/request';

@Pipe({
  name: 'emailFilter',
  pure: false
})
export class EmailFilterPipe implements PipeTransform {

  transform(requestList: Array<Request>, filterValue: string): any {
    if (!requestList || !filterValue) {
      return requestList;
    }
    const normalizedFilter = filterValue.toLowerCase();
    return requestList.filter(request =>
      (request.Email || '').toLowerCase().indexOf(normalizedFilter) !== -1
    );
  }

}
